var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFastDelivery = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "currentColor",
    viewBox: "0 0 80 80",
    stroke: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 78c19.33 0 35-8.73 35-19.5S62.33 39 43 39 8 47.73 8 58.5 23.67 78 43 78Z",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M48 53.049V24.533c0-1.167.707-2.21 1.803-2.663l24.114-9.866c.041-.014.083.013.083.054v30.795l-24.655 11.06A.954.954 0 0 1 48 53.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M45.937 22.491 22.031 12.2c-.041-.014-.041-.071 0-.1L47.765 1.107a1.326 1.326 0 0 1 1.044 0l25.005 10.82c.248.1.248.472 0 .572L50.65 22.49a5.713 5.713 0 0 1-4.713 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M22.494 11.027c-.24-.098-.494.084-.494.351l.468 30.696c0 .8.467 1.517 1.175 1.812l24.313 10.11c.027.014.054-.014.04-.028l-.066-30.584c0-.66-.374-1.236-.949-1.502L22.494 11.027Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M61 18.185V31l7-3.406V15l-7 3.185ZM59.708 18 53 14.64 61.234 11 68 14.39 59.708 18ZM35.27 17 61 6.015l-11.8-4.8a2.384 2.384 0 0 0-1.918-.027L23.153 11.595c-.204.094-.204.39 0 .47L35.271 17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.44 59.78 2 44.95l11.38-.928c4.678-.282 9.753 2.22 12.197 6.168l9.267 5.165c2.74 1.156 4.243 4.19.85 5.837l.084-.008 16.601-1.715c1.808-.185 3.425 1.114 3.605 2.905.179 1.783-1.14 3.369-2.94 3.545l-20.433 2.03a10.664 10.664 0 0 1-5.174-.784l-18.8-7.909-5.197.525Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4 60.47 9.14 60l18.883 7.405a8.595 8.595 0 0 0 3.928.56l21.111-1.836c1.775-.154 3.085-1.6 2.925-3.243-.162-1.658-1.767-2.876-3.574-2.704l-16.948 1.61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m2 44.968 10.62-.916c5.184-.445 10.201 1.97 13.154 6.334l11.027 6.078c1.32 1.014 1.592 2.926.606 4.287a2.99 2.99 0 0 1-4.233.644l-12.32-6.904"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFastDelivery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fast-delivery.3aa19a52d14599efa74d2c7127578105.svg";